import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=6c7774fa"
import script from "./AddTicket.vue?vue&type=script&lang=js"
export * from "./AddTicket.vue?vue&type=script&lang=js"
import style0 from "./AddTicket.vue?vue&type=style&index=0&id=6c7774fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports